import React, { useEffect, useState, useRef } from "react";
import { Col, Input, Row, Table, Tooltip } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { allapiAction } from "../../Redux/common/action";
import moment from "moment";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { URL } from "../../Redux/common/url";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import { AsyncPaginate } from "react-select-async-paginate";

function Sale() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const searchData = searchParams.get("search");
  const componentRef = useRef();
  const { confirm } = Modal;
  const page = pagev == null ? 1 : pagev;
  const search = searchData == null ? "" : searchData;

  const order_list = useSelector((state) =>
    state?.allapi?.order_list ? state?.allapi?.order_list : {}
  );
  const order_details = useSelector((state) =>
    state?.allapi?.order_details ? state?.allapi?.order_details : {}
  );
  const get_invoice_details = useSelector((state) =>
    state?.allapi?.get_invoice_details ? state?.allapi?.get_invoice_details : {}
  );

  const [pages, setPage] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userId, setuserId] = useState("");

  const [statusData, setstatusData] = useState({});
  const [userData, setuserData] = useState({});
  const [statusDataBox, setstatusDataBox] = useState(false);
  const [statusDataBoxView, setstatusDataBoxView] = useState(false);
  const [statusDataBoxReturn, setstatusDataBoxReturn] = useState(false);
  const [statusDataBoxReturn2, setstatusDataBoxReturn2] = useState(false);
  const [statusDataBoxReturn1, setstatusDataBoxReturn1] = useState(false);
  const [productID, setproductID] = useState("");
  const [statusUpTrStatus, setstatusUpTrStatus] = useState("");
  const [statusUpTrId, setstatusUpTrId] = useState("");

  const listdata = order_list?.docs ? order_list?.docs : [];

  const [userselete1, setuserselete1] = useState(null);
  const loadOptionsPalyer1 = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/searchingUserForSall?key=${search}&page=${pages?.page}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.fullName + ", " + data?.referId;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };
  const loadOptionsPalyer2 = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/searchingSalesManForSall?key=${search}&page=${pages?.page}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.fullName + ", " + data?.referId;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };
  const [userselete, setuserselete] = useState(null);
  const [userselete2, setuserselete2] = useState(null);
  useEffect(() => {
    getdataList();
    // dispatch(allapiAction.getInvoceDetails());
    return () => {};
  }, [location, userselete, userselete2]);
  useEffect(() => {
    dispatch(allapiAction.getInvoceDetails());
    return () => {};
  }, []);

  // const getdataList = async () => {
  //   if (search) {
  //     dispatch(allapiAction.getSearchOrderAdmin({ page: page, key: search }));
  //   } else {
  //     dispatch(allapiAction.getuserOrderAdmin(page));
  //   }
  // };
  const getdataList = async () => {
    const obj = {
      page: page,
      // _id: id,
    };
    console.log("rrrrrrrrrr--2");
    if (search) {
      obj.key = search;
    }
    // console.log("rrrrrrrrrr---3");
    // if (monthdata && monthdata !== "null") {
    //   obj.monthyears = monthdata;
    // }
    // if (type && type !== "null") {
    //   obj.type = type;
    // }
    if (userselete && userselete !== "null") {
      obj.party = userselete?._id;
    }
    if (userselete2 && userselete2 !== "null") {
      obj.salesman = userselete2?._id;
    }
    console.log("rrrrrrrrrr--4");
    await dispatch(allapiAction.getSearchOrderAdmin(obj));
    console.log("rrrrrrrrrr--5");
    // if (search) {
    //   dispatch(
    //     allapiAction.getvisitvendorList({ page: page, key: search, _id: id  })
    //   );
    // } else {
    //   dispatch(allapiAction.getvisitvendorList({ page, _id: id }));
    // }
  };
  const [amountdata, setamountdata] = useState({ amountnew: "", type: "" });
  const hendleTochangeAmountdata = (e) => {
    setamountdata({ ...amountdata, [e.target.name]: e.target.value });
  };
  console.log(amountdata);

  const updateToAmount = async (e) => {
    if (!amountdata?.amountnew) {
      return toast?.error("please enter amount");
    }
    if (!amountdata?.type) {
      return toast?.error("please select offer type");
    }

    const response = await dispatch(
      allapiAction.getupdateOfferOrderDetails({
        OrderId: e,
        amountnew: amountdata?.amountnew,
        type: amountdata?.type,
      })
    );

    if (response?.success) {
      getdataList();
    }
    // getupdateOfferOrderDetails
  };

  const hendleTocollectModel = (e) => {
    setstatusUpTrId(e);
    setstatusDataBoxReturn1(true);
  };
  const hendleTocollectModel2 = (e) => {
    setstatusUpTrId(e);
    setstatusDataBoxReturn2(true);
  };

  const [amountCollect, setamountCollect] = useState({});

  const hendeltochangecollect = (e) => {
    setamountCollect({ ...amountCollect, [e.target.name]: e.target.value });
  };
  const [amountCollect1, setamountCollect1] = useState({});

  const hendeltochangecollect1 = (e) => {
    setamountCollect1({ ...amountCollect1, [e.target.name]: e.target.value });
  };
  const hendletoAddress = async (e) => {
    if (!amountCollect1?.name) {
      return toast?.error("please enter name");
    }

    if (!amountCollect1?.email) {
      return toast?.error("please enter email");
    }
    if (!amountCollect1?.phone) {
      return toast?.error("please enter phone");
    }
    if (!amountCollect1?.city) {
      return toast?.error("please enter city");
    }
    if (!amountCollect1?.state) {
      return toast?.error("please enter state");
    }
    if (!amountCollect1?.trackingId) {
      return toast?.error("please enter trackingId");
    }
    if (!amountCollect1?.courierCompany) {
      return toast?.error("please enter courier Company ");
    }

    if (!amountCollect1?.pincode) {
      return toast?.error("please enter pincode");
    }
    if (!amountCollect1?.address) {
      return toast?.error("please enter address");
    }
    const response = await dispatch(
      allapiAction.createAddressAdmin({
        _id: statusUpTrId?._id,
        name: amountCollect1?.name,
        address: amountCollect1?.address,
        pincode: amountCollect1?.pincode,
        country: "Ïndia",
        state: amountCollect1?.state,
        city: amountCollect1?.city,
        phone: amountCollect1?.phone,
        email: amountCollect1?.email,
        trackingId: amountCollect1?.trackingId,
        courierCompanynumber: amountCollect1?.courierCompanynumber,
        courierCompany: amountCollect1?.courierCompany,
        noOfBox: amountCollect1?.noOfBox,
        biltyNo: amountCollect1?.biltyNo,
      })
    );

    if (response?.success) {
      getdataList();
      setstatusDataBoxReturn2(false);
      setamountCollect1({
        name: "",
        discription: "",
        pincode: "",
        state: "",
        phone: "",
        city: "",
        email: "",
        courierCompany: "",
        courierCompanynumber: "",
        noOfBox: "",
        biltyNo: "",
        trackingId: "",
      });
    }
    // getupdateOfferOrderDetails
  };
  const hendleTocollectAmount = async (e) => {
    if (!amountCollect?.amount) {
      return toast?.error("please enter amount");
    }
    if (!amountCollect?.discription) {
      return toast?.error("please enter discription");
    }
    if (!amountCollect?.paymenttype) {
      return toast?.error("please enter payment type");
    }

    const response = await dispatch(
      allapiAction.collectAmount({
        _id: statusUpTrId?._id,
        amount: amountCollect?.amount,
        discription: amountCollect?.discription,
        paymenttype: amountCollect?.paymenttype,
        transactionid: amountCollect?.transactionid,
      })
    );

    if (response?.success) {
      getdataList();
      setstatusDataBoxReturn1(false);
      setamountCollect({
        amount: "",
        discription: "",
        paymenttype: "",
        transactionid: "",
      });
    }
    // getupdateOfferOrderDetails
  };
  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleDelete = (e) => {
    dispatch(allapiAction.deleteProduct({ productId: e, pageNo: page }));
    return () => {};
  };
  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const hendleToViewM = (e) => {
    setstatusDataBox(true);
    setuserData(e);
    setproductID(e);
    dispatch(allapiAction.getuserOrderDetails({ _id: e?._id }));
  };
  const hendleToViewProduct = (e) => {
    setstatusDataBoxView(true);
    setuserData(e);
    setproductID(e);
    dispatch(allapiAction.getuserOrderDetails({ _id: e?._id }));
  };
  const hendleToViewReturn = (e) => {
    setstatusDataBoxReturn(true);
    setstatusUpTrId(e);
  };
  const hendleSubmitReturn = (e) => {
    setstatusDataBoxReturn(false);
    dispatch(
      allapiAction.cancelOrderByAdmin({
        _id: statusUpTrId?._id,
        user_id: statusUpTrId?.user_id?._id,
        description: statusUpTrStatus,
        page: page,
      })
    );
    setstatusUpTrStatus("");
  };

  const shippingCharge = order_details?.orderproductsList?.reduce(
    (total, obj) => {
      return total + parseInt(obj?.delivery_charges);
    },
    0
  );
  const totalSubtotalPricegstdd = order_details?.orderproductsList?.reduce(
    (total, obj) => {
      return total + (obj.sub_total * obj?.gst) / 100;
    },
    0
  );
  const totalAmount = order_details?.sub_total + shippingCharge;
  const hendleTochangedata = (e) => {
    const { name, value } = e.target;

    setstatusData({ ...statusData, [name]: value });
  };

  const hendleToSubmetUpdate = () => {
    dispatch(
      allapiAction.addFoundByAdmin({
        id: userData?._id,
        amount: statusData?.amount,

        pageNumber: page,
      })
    );

    setstatusDataBox(false);
  };

  const showModal = (e) => {
    setuserId(e);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    dispatch(
      allapiAction.user_inactive({
        _id: userId,
        status: userId,
        // active: 0,
        pageNumber: page,
      })
    );
    setuserId("");
    setIsModalOpen(false);
    return () => {};
  };

  const hendleToChangeStatus = (id, status) => {
    dispatch(
      allapiAction.user_inactive({
        _id: id,
        status: status,
        // active: 0,
        pageNumber: page,
      })
    );
    // setuserId("");
    // setIsModalOpen(false);
    return () => {};
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusProduct({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    {
      title: "Sell Code",
      dataIndex: "sellCode",
      key: "sellCode",
      className: "table_action_col",
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <div style={{ width: "100px" }}>
    //           <img
    //             style={{ width: "100%" }}
    //             src={URL?.API_BASE_URL + item?.featureImage}
    //             alt=""
    //           />
    //         </div>
    //       </>
    //     );
    // //   },
    // },

    {
      title: "Buyer",
      dataIndex: "referId",
      key: "referId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer coustomNevc"
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.user_id?.fullName},<p> {item?.user_id?.displayName}</p>
              <p> {item?.user_id?.referId}</p>
            </span>
          </>
        );
      },
    },

    // {
    //   title: "Sponsor Code",
    //   dataIndex: "referByuserId",
    //   key: "referByuserId",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         {/* <Tooltip title="Contact"> */}
    //         <span
    //           className="cursor-pointer coustomNevc"
    //           // onClick={() => navigate(`/user-details/${item?.referId}`)}
    //         >
    //           {item?.user_id?.referByuserId?.fullName}

    //           <p> {item?.user_id?.referByuserId?.referId}</p>
    //         </span>
    //       </>
    //     );
    //   },
    // },

    {
      title: "Buyer Number",
      dataIndex: "phone",
      key: "phone",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.user_id?.phone}
            </span>
          </>
        );
      },
    },
    // {
    //   title: "Name",
    //   dataIndex: "title",
    //   key: "title",
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title={item?.status}>
    //           <button
    //             className={
    //               item?.status == "Active"
    //                 ? "success-button ml-3"
    //                 : "delete-button ml-3"
    //             }
    //             onClick={() =>
    //               hendleToStatus(
    //                 item?._id,
    //                 item?.status == "Active" ? "Inactive" : "Active"
    //               )
    //             }
    //           >
    //             {item?.status}
    //           </button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Upline Id",
    //   dataIndex: "referBy",
    //   key: "referBy",
    // },
    // {
    //   title: "Number",
    //   dataIndex: "phone",
    //   key: "phone",
    // },
    // {
    //   title: "Password",
    //   dataIndex: "passwordPlan",
    //   key: "passwordPlan",
    // },
    // {
    //   title: "Wallet",
    //   dataIndex: "balance",
    //   key: "balance",
    // },
    // {
    //   title: "Wallet",
    //   dataIndex: "Wallet",
    //   key: "Wallet",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>

    //         <span
    //           className="cursor-pointer"
    //           // onClick={() => navigate(`/users/contact/${item?.id}`)}
    //         >
    //           {item?.walletId?.closeBal}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Reffer Code",
    //   dataIndex: "referCode",
    //   key: "referCode",
    // },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer"
              // onClick={() => navigate(`/users/contact/${item?.id}`)}
            >
              {moment(item?.createdAt).format(" DD/MM/YYYY ")}
            </span>
          </>
        );
      },
    },
    //     {
    //       title: "Status",
    //       dataIndex: "status",
    //       key: "status",
    //       className: "table_action_col",
    //       render: (value, item, index) => {

    //         const userRank =
    //         item?.status == '0'
    //           ? 'free'
    //           : item?.status == '1'
    //           ? 'FRANCHISE'
    //           : item?.status == '2'
    //           ? 'BARON'
    //           : item?.status == '3'
    //           ? 'COUNT'
    //           : item?.status == '4'
    //           ? 'MARQUISE'
    //           : item?.status == '4'
    //           ? 'DUKE'
    //           : 'ARCH DUKE'
    //         return (
    //           <>

    // <span
    //               className="cursor-pointer"

    //             >
    //              {userRank}
    //             </span>

    //           </>
    //         );
    //       },
    //     },
    {
      title: "Amount",
      dataIndex: "sub_total",
      key: "sub_total",
    },
    {
      title: "Paid Amount",
      dataIndex: "paidAmount",
      key: "paidAmount",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <span
              className="cursor-pointer"
              // onClick={() => navigate(`/users/contact/${item?.id}`)}
            >
              {item?.paidAmount}
            </span>
          </>
        );
      },
    },
    {
      title: "Remaining Amount",
      dataIndex: "reaminingAmount",
      key: "reaminingAmount",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <span
              className="cursor-pointer"
              // onClick={() => navigate(`/users/contact/${item?.id}`)}
            >
              {item?.sub_total - item?.paidAmount}
            </span>
          </>
        );
      },
    },
    // {
    //   title: "Payment Mode",
    //   dataIndex: "payment_mode_name",
    //   key: "payment_mode_name",
    // },
    {
      title: "Production Status",
      dataIndex: "productionStatus",
      key: "productionStatus",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <span
              className="cursor-pointer"
              style={
                item.productionStatus == "pending"
                  ? { color: "red" }
                  : { color: "green" }
              }
            >
              {item?.productionStatus}
            </span>
          </>
        );
      },
    },
    {
      title: "Delivery status",
      dataIndex: "delivery_status",
      key: "delivery_status",
    },
    // {
    //   title: "Order return",
    //   dataIndex: "orderretune",
    //   key: "orderretune",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <span
    //           className="cursor-pointer"
    //           // onClick={() => navigate(`/users/contact/${item?.id}`)}
    //         >
    //           {item?.orderretune == "true" ? "Yes" : "No"}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact">
              <span
                className="cursor-pointer"
                onClick={() => navigate(`/users/contact/${item?.id}`)}
              >
                <SvgIcon.contacts className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            {/* <Tooltip title="delete">
              <button
                className="filter-button ml-3"
                onClick={() => showModal(item?.id)}
              >
                Delete
              </button>
            </Tooltip> */}
            <Tooltip title="Invoice">
              <button
                className="filter-button ml-3  mt-5"
                onClick={() => hendleToViewM(item)}
              >
                Invoice
              </button>
            </Tooltip>
            <Tooltip title="View">
              <button
                className="filter-button ml-3  mt-5"
                onClick={() => hendleToViewProduct(item)}
              >
                View
              </button>
            </Tooltip>
            <Tooltip title="Collect Amount">
              <button
                className="filter-button ml-3  mt-5"
                onClick={() => hendleTocollectModel(item)}
              >
                Collect Amount
              </button>
            </Tooltip>
            <Tooltip title="Dispatch">
              <button
                className="filter-button ml-3  mt-5"
                onClick={() => hendleTocollectModel2(item)}
              >
                Dispatch
              </button>
            </Tooltip>
            {/* <Tooltip title="Return Order">
               
              <button
                className="filter-button ml-3  mt-5"
                onClick={() => hendleToViewReturn(item)}
              >
                Order Return
              </button>
            </Tooltip> */}
          </>
        );
      },
    },
  ];

  const [searchs, setsearch] = useState("");
  const handleChange = (e) => {
    setsearch(e);
    setPage(1);
    navigate("/sale?page=" + 1 + "&search=" + e);
  };

  const hendlePahegi = (e) => {
    setPage(e);
    navigate("/sale?page=" + e + "&&search=" + search);
  };

  return (
    <div>
      <Modal
        title="delete User"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>Are you sure delete</p>
      </Modal>

      <Modal
        title="Inovice"
        centered
        open={statusDataBox}
        // onOk={() => hendleToSubmetUpdate(false)}
        onCancel={() => setstatusDataBox(false)}
        width={800}
      >
        <div
          id="kt_app_content"
          className="app-content flex-column-fluid"
          ref={componentRef}
        >
          {/* -begin::Content container-*/}
          <div
            id="kt_app_content_container"
            className="app-container container-xxl"
          >
            {/* - begin::Invoice 3-*/}
            <div className="">
              {/* - begin::Body-*/}
              <div className="card-body pl-15 pr-15">
                {/* - begin::Wrapper-*/}
                <div className="mw-lg-950px mx-auto w-100">
                  {/* - begin::Header-*/}

                  <div className="d-flex justify-content-between flex-column flex-sm-row mb-19">
                    <div>
                      <h4 className="fw-bolder text-gray-800 fs-2qx pe-5 pb-7">
                        INVOICE
                      </h4>
                      {/* -end::Logo-*/}
                      <div className="fw-bold fs-2 ">
                        Dear, {order_details?.address_id?.name}
                        {/* <span className='fs-6'>(f.mit@kpmg.com)</span>, */}
                        <br />
                        <span className="text-muted  companyName">
                          Email : {order_details?.address_id?.email}
                        </span>
                        <br />
                        <span className="text-muted  companyName">
                          Number : {order_details?.address_id?.phone}
                        </span>
                        <br />
                        <span className="text-muted  companyName">
                          Address : {order_details?.address_id?.address}
                        </span>
                        <br />
                        <span className="text-muted  companyName">
                          City : {order_details?.address_id?.city}
                        </span>
                        <br />
                        <span className="text-muted  companyName">
                          State : {order_details?.address_id?.state}
                        </span>
                        <br />
                        <span className="text-muted  companyName">
                          Pincode : {order_details?.address_id?.pincode}
                        </span>
                        <span className="text-muted  companyName">
                          {/* Here are your order details. We thank you for your purchase. */}
                          {/* sd */}
                        </span>
                      </div>
                    </div>

                    <div className="text-sm-end">
                      {/* -begin::Logo-*/}
                      <a
                        href="#"
                        style={{ width: "150px" }}
                        className="d-block mw-150px ms-sm-auto"
                      >
                        <img
                          alt="Logo"
                          src={
                            URL.API_BASE_URL + get_invoice_details?.invoiceLogo
                          }
                          className="w-100"
                        />
                      </a>
                      {/* -end::Logo-*/}
                      {/* -begin::Text-*/}
                      <div className="text-sm-end fw-semibold fs-4 text-muted mt-7">
                        <div className="companyName">
                          {get_invoice_details?.companyName}
                        </div>
                        <div className="companyName">
                          {get_invoice_details?.email}
                        </div>
                        <div className="companyName">
                          {get_invoice_details?.address}
                        </div>
                        {/* <div>Mississippi 96522</div> */}
                      </div>
                      {/* -end::Text-*/}
                    </div>
                  </div>
                  {/* -end::Header-*/}
                  {/* -begin::Body-*/}
                  <div className="pb-12">
                    {/* -begin::Wrapper-*/}
                    <div className="d-flex flex-column gap-7 gap-md-10">
                      {/* -begin::Message-*/}
                      <div className="fw-bold fs-2">
                        Dear, {order_details?.address_id?.name}
                        {/* <span className='fs-6'>(f.mit@kpmg.com)</span>, */}
                        <br />
                        <span className="text-muted fs-5">
                          {/* Here are your order details. We thank you for your purchase. */}
                        </span>
                      </div>
                      {/* -begin::Message-*/}
                      {/* -begin::Separator-*/}
                      <div className="separator"></div>
                      {/* -begin::Separator-*/}
                      {/* -begin::Order details-*/}
                      <div className="d-flex flex-column flex-sm-row gap-7 gap-md-10 fw-bold">
                        <div className="flex-root d-flex col-6 flex-column">
                          <span className="text-muted">Order ID</span>
                          <span className="fs-5">#{productID?._id}</span>
                          <span className="text-muted">Transation ID</span>
                          <span className="fs-5">
                            #{productID?.transationId}
                          </span>
                          <span className="text-muted">Paid Status</span>
                          <span className="fs-5">{productID?.paidstatus}</span>
                        </div>
                        <div className="flex-root d-flex col-6 flex-column">
                          <span className="text-muted">Date</span>
                          <span className="fs-5">
                            {moment(productID?.createdAt).format(
                              " MMMM Do YYYY"
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between flex-column">
                        <div className="table-responsive border-bottom mb-9">
                          <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                            <thead>
                              <tr className="border-bottom fs-6 fw-bold text-muted">
                                <th>S.No</th>
                                <th className="min-w-175px pb-2">Item</th>
                                <th className="min-w-70px text-end pb-2">
                                  Color
                                </th>
                                <th className="min-w-70px text-end pb-2">
                                  Size
                                </th>
                                <th className="min-w-70px text-end pb-2">
                                  Unit Cost
                                </th>
                                <th className="min-w-80px text-end pb-2">
                                  Quantity
                                </th>
                                <th className="min-w-80px text-end pb-2">
                                  Net Amount
                                </th>
                                <th className="min-w-80px text-end pb-2">
                                  Tex (₹)
                                </th>
                                <th className="min-w-100px text-end pb-2">
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody className="fw-semibold invotb text-gray-600">
                              {order_details?.orderproductsList &&
                                order_details?.orderproductsList?.map(
                                  (data, i) => {
                                    const totalPrice = data?.product_price;
                                    const gstRate = data?.gst;
                                    const basePrice =
                                      totalPrice / (1 + gstRate / 100);
                                    const perProgst = totalPrice - basePrice;

                                    const netAmount =
                                      basePrice * data?.itme_count;

                                    const taxAmount =
                                      perProgst * data?.itme_count;
                                    return (
                                      <tr key={data._id}>
                                        <td className="">{i + 1}</td>
                                        <td>
                                          <div className="d-flex ">
                                            <div className="">
                                              <div className="fw-bold">
                                                {data?.product_names}
                                              </div>
                                              <div className="fs-7 text-muted"></div>
                                            </div>
                                          </div>
                                        </td>
                                        <td className="text-end">
                                          {" "}
                                          {data?.colorId?.color}
                                        </td>
                                        <td className="text-end">
                                          {" "}
                                          {data?.sizeId?.size}
                                        </td>
                                        <td className="text-end">
                                          {" "}
                                          {basePrice.toFixed(2)}
                                        </td>
                                        <td className="text-end">
                                          {" "}
                                          {data?.itme_count}
                                        </td>

                                        <td className="text-end">
                                          {" "}
                                          {netAmount?.toFixed(2)}
                                        </td>
                                        <td className="text-end">
                                          {" "}
                                          {taxAmount?.toFixed(2)}
                                        </td>
                                        <td className="text-end">
                                          ₹ {data?.sub_total}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              <tr>
                                <td colSpan={8} className="text-end">
                                  Subtotal
                                </td>
                                <td className="text-end">
                                  ₹ {order_details?.sub_total}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={8} className="text-end">
                                  Shipping
                                </td>
                                <td className="text-end">₹ {shippingCharge}</td>
                              </tr>
                              <tr>
                                <td
                                  colSpan={8}
                                  className="fs-3 text-dark fw-bold text-end"
                                >
                                  Grand Total
                                </td>
                                <td className="text-dark fs-3 fw-bolder text-end">
                                  ₹ {totalAmount}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6"></div>
          <div className="col-6">
            <ReactToPrint
              trigger={() => (
                <Button variant="primary" onClick={hendleDelete}>
                  Print / Download
                </Button>
              )}
              content={() => componentRef.current}
            />
          </div>
        </div>
      </Modal>
      <Modal
        title="Order Details"
        centered
        open={statusDataBoxView}
        onOk={() => setstatusDataBoxView(false)}
        onCancel={() => setstatusDataBoxView(false)}
        width={1200}
      >
        <div className="">
          <div>
            <div className="row">
              <div className="col-4">
                <h6> Order Code : -</h6>
              </div>
              <div className="col-8">
                <p>{order_details?.sellCode}</p>
              </div>
              {/* 
              <div className="col-4">
                <h6>payment mode name : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.payment_mode_name}</p>
              </div> */}

              <div className="col-4">
                <h6>sub total : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.sub_total}</p>
              </div>
            </div>
            <hr />
            <h3>user Details</h3>
            <div className="row">
              <div className="col-4">
                <h6> user id : -</h6>
              </div>
              <div className="col-8">
                <p>{order_details?.user_id?._id}</p>
              </div>

              <div className="col-4">
                <h6>user reffer id : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.user_id?.referId}</p>
              </div>

              <div className="col-4">
                <h6>full name : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.user_id?.fullName}</p>
              </div>
              <div className="col-4">
                <h6>Email : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.user_id?.email}</p>
              </div>
            </div>
            <hr />
            {order_details?.address_id && <h3>shipping address</h3>}
            {order_details?.address_id && (
              <div className="row">
                <div className="col-4">
                  <h6> name : -</h6>
                </div>
                <div className="col-8">
                  <p>{order_details?.address_id?.name}</p>
                </div>

                <div className="col-4">
                  <h6>email : -</h6>
                </div>

                <div className="col-8">
                  <p>{order_details?.address_id?.email}</p>
                </div>

                <div className="col-4">
                  <h6>phone : -</h6>
                </div>

                <div className="col-8">
                  <p>{order_details?.address_id?.phone}</p>
                </div>
                <div className="col-4">
                  <h6>address : -</h6>
                </div>

                <div className="col-8">
                  <p>{order_details?.address_id?.address}</p>
                </div>
                <div className="col-4">
                  <h6>city : -</h6>
                </div>
                <div className="col-8">
                  <p>{order_details?.address_id?.city}</p>
                </div>
                <div className="col-4">
                  <h6>state : -</h6>
                </div>
                <div className="col-8">
                  <p>{order_details?.address_id?.state}</p>
                </div>
                <div className="col-4">
                  <h6>pincode : -</h6>
                </div>

                <div className="col-8">
                  <p>{order_details?.address_id?.pincode}</p>
                </div>
              </div>
            )}

            <hr />
            <h3>Order Product</h3>

            <div className="d-flex justify-content-between flex-column odpd">
              <div className="table-responsive border-bottom mb-9">
                <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                  <thead>
                    <tr className="border-bottom fs-6 fw-bold text-muted">
                      <th>S.No</th>
                      <th className="min-w-175px pb-2">Item</th>
                      <th className="min-w-70px text-end pb-2">Color</th>
                      <th className="min-w-70px text-end pb-2">Size</th>
                      <th className="min-w-70px text-end pb-2">Unit Cost</th>
                      <th className="min-w-80px text-end pb-2">Quantity</th>
                      <th className="min-w-70px text-end pb-2">
                        Complete Quantity
                      </th>

                      <th className="min-w-80px text-end pb-2">Net Amount</th>
                      <th className="min-w-80px text-end pb-2">Tex (₹)</th>
                      <th className="min-w-100px text-end pb-2">Amount</th>
                      <th className="min-w-100px text-end pb-2">Amount</th>
                      <th className="min-w-100px text-end pb-2">
                        Precent / Amount
                      </th>
                      <th className="min-w-100px text-end pb-2">Action</th>
                    </tr>
                  </thead>
                  <tbody className="fw-semibold invotb text-gray-600">
                    {order_details?.orderproductsList &&
                      order_details?.orderproductsList?.map((data, i) => {
                        const totalPrice = data?.product_price;
                        const gstRate = data?.gst;
                        const basePrice = totalPrice / (1 + gstRate / 100);
                        const perProgst = totalPrice - basePrice;

                        const netAmount = basePrice * data?.itme_count;

                        const taxAmount = perProgst * data?.itme_count;
                        return (
                          <tr key={data._id}>
                            <td className="">{i + 1}</td>
                            <td>
                              <div className="d-flex ">
                                <div className="">
                                  <div className="fw-bold">
                                    {data?.product_names}
                                  </div>
                                  <div className="fs-7 text-muted"></div>
                                </div>
                              </div>
                            </td>
                            <td className="text-end">
                              {" "}
                              {data?.colorId?.color}
                            </td>
                            <td className="text-end"> {data?.sizeId?.size}</td>
                            <td className="text-end">
                              {" "}
                              {basePrice.toFixed(2)}
                            </td>
                            <td className="text-end"> {data?.itme_count}</td>
                            <td className="text-end">
                              {" "}
                              {data?.complete_itme_count
                                ? data?.complete_itme_count
                                : 0}
                            </td>

                            <td className="text-end">
                              {" "}
                              {netAmount?.toFixed(2)}
                            </td>
                            <td className="text-end">
                              {" "}
                              {taxAmount?.toFixed(2)}
                            </td>
                            <td className="text-end">₹ {data?.sub_total}</td>
                            <td className="text-end">
                              {" "}
                              <input
                                placeholder="Enter Amount"
                                type="number"
                                className="form-control"
                                value={amountdata?.amountnew}
                                name="amountnew"
                                onChange={(e) => hendleTochangeAmountdata(e)}
                              />{" "}
                            </td>
                            <td className="text-end">
                              <select
                                name="type"
                                value={amountdata?.type}
                                onChange={(e) => hendleTochangeAmountdata(e)}
                              >
                                <option value={""}>Select </option>
                                <option value={"percentage"}>Precent</option>
                                <option value={"Amount"}>Amount</option>
                              </select>{" "}
                            </td>
                            <td className="text-end">
                              <button
                                type="button"
                                class="btn btn-dark btn-sm"
                                onClick={(e) => updateToAmount(data?._id)}
                              >
                                {" "}
                                Submit{" "}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    <tr>
                      <td colSpan={9} className="text-end">
                        Subtotal
                      </td>
                      <td className="text-end">₹ {order_details?.sub_total}</td>
                    </tr>
                    <tr>
                      <td colSpan={9} className="text-end">
                        Shipping
                      </td>
                      <td className="text-end">₹ {shippingCharge}</td>
                    </tr>
                    <tr>
                      <td
                        colSpan={9}
                        className="fs-3 text-dark fw-bold text-end"
                      >
                        Grand Total
                      </td>
                      <td className="text-dark fs-3 fw-bolder text-end">
                        ₹ {totalAmount}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <h3>Payment Details</h3>

            <div className="d-flex justify-content-between flex-column odpd">
              <div className="table-responsive border-bottom mb-9">
                <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                  <thead>
                    <tr className="border-bottom fs-6 fw-bold text-muted">
                      <th>S.No</th>
                      <th className="min-w-175px pb-2">Collect By</th>
                      <th className="min-w-70px text-end pb-2">Amount</th>
                      <th className="min-w-70px text-end pb-2">Type</th>
                      <th className="min-w-70px text-end pb-2">Payment type</th>
                      <th className="min-w-70px text-end pb-2">
                        Transaction id
                      </th>
                      <th className="min-w-70px text-end pb-2">Discription</th>
                      <th className="min-w-70px text-end pb-2">Date</th>
                    </tr>
                  </thead>
                  <tbody className="fw-semibold invotb text-gray-600">
                    {order_details?.paymentList &&
                      order_details?.paymentList?.map((data, i) => {
                        return (
                          <tr key={data._id}>
                            <td className="">{i + 1}</td>
                            <td>
                              <div className="d-flex ">
                                <div className="">
                                  <div className="fw-bold">
                                    {data?.collectby_id?.fullName +
                                      ", " +
                                      data?.collectby_id?.phone}
                                  </div>
                                  <div className="fs-7 text-muted"></div>
                                </div>
                              </div>
                            </td>
                            <td className="text-end"> {data?.amount}</td>
                            <td className="text-end"> {data?.type}</td>
                            <td className="text-end"> {data?.paymenttype}</td>
                            <td className="text-end"> {data?.transactionid}</td>
                            <td className="text-end"> {data?.discription}</td>
                            <td className="text-end">
                              {" "}
                              {moment(data?.createdAt).format(
                                "DD-MM-YYYY hh:mm A"
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    {/* <tr>
                      <td colSpan={9} className="text-end">
                        Subtotal
                      </td>
                      <td className="text-end">₹ {order_details?.sub_total}</td>
                    </tr>
                    <tr>
                      <td colSpan={9} className="text-end">
                        Shipping
                      </td>
                      <td className="text-end">₹ {shippingCharge}</td>
                    </tr>
                    <tr>
                      <td
                        colSpan={9}
                        className="fs-3 text-dark fw-bold text-end"
                      >
                        Grand Total
                      </td>
                      <td className="text-dark fs-3 fw-bolder text-end">
                        ₹ {totalAmount}
                      </td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>

            {/* {order_details?.orderproductsList &&
              order_details?.orderproductsList?.map((data, i) => {
                return (
                  <div>
                    <div className="row">
                      <div className="col-3">
                        <h6>sub order id</h6>
                      </div>
                      <div className="col-3">
                        <p>{data?.sub_order_id}</p>
                      </div>
                      <div className="col-3">
                        <h6>name</h6>
                      </div>
                      <div className="col-3">
                        <p>{data?.product_names}</p>
                      </div>
                      <div className="col-3">
                        <h6>Color</h6>
                      </div>
                      <div className="col-3">
                        <p>{data?.colorId?.color}</p>
                      </div>
                      <div className="col-3">
                        <h6>size</h6>
                      </div>
                      <div className="col-3">
                        <p>{data?.sizeId?.size}</p>
                      </div>

                      <div className="col-3">
                        <h6>product price</h6>
                      </div>
                      <div className="col-3">
                        <p>{data?.product_price}</p>
                      </div>
                      <div className="col-3">
                        <h6>item Count</h6>
                      </div>
                      <div className="col-3">
                        <p>{data?.itme_count}</p>
                      </div>
                      <div className="col-3">
                        <h6>sub total</h6>
                      </div>
                      <div className="col-3">
                        <p>{data?.sub_total}</p>
                      </div>
                      <div className="col-3">
                        <h6>Complete item </h6>
                      </div>
                      <div className="col-3">
                        <p>{data?.complete_itme_count}</p>
                      </div>
                      <div className="col-3">
                        <h6>feture image</h6>
                      </div>
                      <div className="col-3">
                        <div style={{ width: "100px" }}>
                          <img
                            src={URL.API_BASE_URL + data?.colorId?.featureImage}
                            alt=""
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                );
              })} */}
          </div>
        </div>
      </Modal>
      <Modal
        title="Return order"
        centered
        open={statusDataBoxReturn}
        onOk={() => hendleSubmitReturn(false)}
        onCancel={() => setstatusDataBoxReturn(false)}
        width={500}
      >
        <div>
          <Row>
            <Col span={24}>Description</Col>
            <Col span={24}>
              <Input
                name="description"
                placeholder="enter description..."
                value={statusUpTrStatus}
                onChange={(e) => {
                  setstatusUpTrStatus(e?.target?.value);
                }}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal
        title="Dispatch order"
        centered
        open={statusDataBoxReturn2}
        onOk={() => hendletoAddress(false)}
        onCancel={() => setstatusDataBoxReturn2(false)}
        width={500}
      >
        <div>
          <Row>
            <Col span={24}>Name</Col>
            <Col span={24}>
              <Input
                name="name"
                type="text"
                placeholder="enter name"
                value={amountCollect1?.name}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>Email</Col>
            <Col span={24}>
              <Input
                name="email"
                type="text"
                placeholder="enter email"
                value={amountCollect1?.email}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>Phone</Col>
            <Col span={24}>
              <Input
                name="phone"
                type="text"
                placeholder="enter phone"
                value={amountCollect1?.phone}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>City</Col>
            <Col span={24}>
              <Input
                name="city"
                type="text"
                placeholder="enter city"
                value={amountCollect1?.city}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>State</Col>
            <Col span={24}>
              <Input
                name="state"
                type="text"
                placeholder="enter state"
                value={amountCollect1?.state}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>Pincode</Col>
            <Col span={24}>
              <Input
                name="pincode"
                type="text"
                placeholder="enter pincode"
                value={amountCollect1?.pincode}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>Address</Col>
            <Col span={24}>
              <Input
                name="address"
                type="text"
                placeholder="enter address"
                value={amountCollect1?.address}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>Courier Company</Col>
            <Col span={24}>
              <Input
                name="courierCompany"
                type="text"
                placeholder="enter courier company"
                value={amountCollect1?.courierCompany}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>Courier Company number</Col>
            <Col span={24}>
              <Input
                name="courierCompanynumber"
                type="text"
                placeholder="enter courier company number"
                value={amountCollect1?.courierCompanynumber}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>Tracking Id</Col>
            <Col span={24}>
              <Input
                name="trackingId"
                type="text"
                placeholder="enter tracking Id"
                value={amountCollect1?.trackingId}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>Bilty No</Col>
            <Col span={24}>
              <Input
                name="biltyNo"
                type="text"
                placeholder="enter bilty No"
                value={amountCollect1?.biltyNo}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
            <Col span={24}>No. Of Box</Col>
            <Col span={24}>
              <Input
                name="noOfBox"
                type="text"
                placeholder="enter no. of box"
                value={amountCollect1?.noOfBox}
                onChange={(e) => {
                  hendeltochangecollect1(e);
                }}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal
        title="Collect Amount"
        centered
        open={statusDataBoxReturn1}
        onOk={() => hendleTocollectAmount(false)}
        onCancel={() => setstatusDataBoxReturn1(false)}
        width={500}
      >
        <div>
          <Row>
            <Col span={24}>Amount</Col>
            <Col span={24}>
              <Input
                name="amount"
                type="number"
                placeholder="enter amount..."
                value={amountCollect?.amount}
                onChange={(e) => {
                  hendeltochangecollect(e);
                }}
              />
            </Col>

            <Col span={24}>Payment type</Col>
            <Col span={24}>
              <Input
                name="paymenttype"
                type="text"
                placeholder="enter paymenttype..."
                value={amountCollect?.paymenttype}
                onChange={(e) => {
                  hendeltochangecollect(e);
                }}
              />
            </Col>
            <Col span={24}>Transaction id</Col>
            <Col span={24}>
              <Input
                name="transactionid"
                type="text"
                placeholder="enter transactionid..."
                value={amountCollect?.transactionid}
                onChange={(e) => {
                  hendeltochangecollect(e);
                }}
              />
            </Col>
            <Col span={24}>discription</Col>
            <Col span={24}>
              <Input
                name="discription"
                type="text"
                placeholder="enter discription..."
                value={amountCollect?.discription}
                onChange={(e) => {
                  hendeltochangecollect(e);
                }}
              />
            </Col>
          </Row>
        </div>
      </Modal>

      <div className="flex">
        <div>
          <HeadingBack
            title={"Sale"}
            subHeading={`Total ${order_list?.totalDocs || 0} Sale`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
          />
        </Col>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <AsyncPaginate
            value={userselete2}
            className="liceninputv2"
            // placeholder="location"
            placeholder="Sales Mans"
            loadOptions={loadOptionsPalyer2}
            onChange={setuserselete2}
            additional={{
              page: 1,
            }}
          />
        </Col>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <AsyncPaginate
            value={userselete}
            className="liceninputv2"
            // placeholder="location"
            placeholder="Party"
            loadOptions={loadOptionsPalyer1}
            onChange={setuserselete}
            additional={{
              page: 1,
            }}
          />
        </Col>
      </div>
      <div className="tableResponsive mt-10">
        <Table
          className={"table antd_table"}
          dataSource={listdata}
          columns={columns}
          pagination={{
            current: parseInt(page),
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: order_list?.totalDocs ? order_list?.totalDocs : 0,
          }}
        />
      </div>
    </div>
  );
}

export default Sale;
